export function isSoundCloudUrl(url: string): boolean {
  return /soundcloud\.com|w\.soundcloud\.com/i.test(url);
}

export function isSoundCloudEmbedUrl(url: string): boolean {
  return /w\.soundcloud\.com\/player/i.test(url);
}

export function getSoundCloudEmbedUrl(url: string, autoPlay = false): string {
  return "https://w.soundcloud.com/player/?url=" +
    encodeURIComponent(url) +
    `&auto_play=${autoPlay}&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false`;
}
